import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { SabisNgxDialogService } from 'sabis-components2';
import { FormValues } from 'sabis-dynamicform';
import { EditorData } from 'sabis-dynamicform-core/cjs/Models/DynamicFormModel';
import { CommandResult, EmailCommand, LookupItemDTO } from '../../../shared/api-common-models';
import { FeedbackRequestDialogData, FeedbackRequestEditorComponent } from './feedback-request-editor/feedback-request-editor.component';
import { ReferenceCheckRequestDialogData, FeedbackRequestsListComponent } from './feedback-requests-list/feedback-requests-list.component';
import { StepAction } from 'src/app/settings/recruitment-steps/recruitment-steps.service';

@Injectable({
  providedIn: 'root'
})
export class FeedbackRequestsService {

  constructor(@Inject('API_URL') private _apiUrl: string
    , private _http: HttpClient
    , private _dialogService: SabisNgxDialogService
  ) { }


  public addReferenceCheck(applicationId: number, command: SaveFeedbackRequestCDTO): Observable<number> {
    let url: string = `${this._apiUrl}/admin/feedback-requests/applications/${applicationId}`;

    return this._http.post<number>(url, command);
  }

  /*
   * addReferenceCheck and collectFeedbackRequest methods use the same url link.
   * Although, the difference is in command: isCollectFeedback bool.
   * If true, it means the feedback request will be collected by interviewer. Else, it means the step is of type Reference check/ Feedback request.
   */
  public collectFeedbackRequest(applicationId: number, command: SaveFeedbackRequestCDTO): Observable<number> {
    let url: string = `${this._apiUrl}/admin/feedback-requests/applications/${applicationId}`;

    return this._http.post<number>(url, command);
  }

  public getReferenceCheckRequests(feedbackRequestId: number): Observable<ReferenceCheckRequestListInitDTO> {
    let url: string = `${this._apiUrl}/admin/feedback-requests/${feedbackRequestId}/requests`;

    return this._http.get<ReferenceCheckRequestListInitDTO>(url);
  }

  public getStepFeedbackFormTemplates(selectionStepId: number, applicationId: number): Observable<FeedbackRequestEditorInitDTO> {
    let url: string = `${this._apiUrl}/admin/feedback-requests/feedback-form-templates?selectionStepId=${selectionStepId}&applicationId=${applicationId}`;

    return this._http.get<FeedbackRequestEditorInitDTO>(url);
  }

  public getFeedbackRequestEditorInitData(applicationId: number, selectionStepId: number, stepAction: StepAction): Observable<FeedbackRequestInitDTO> {
    let url: string = `${this._apiUrl}/admin/feedback-requests?applicationId=${applicationId}&selectionStepId=${selectionStepId}&stepAction=${stepAction}`;

    return this._http.get<FeedbackRequestInitDTO>(url);
  }

  public deleteRequestClick(feedbackRequestId: number): Observable<CommandResult> {
    let url: string = `${this._apiUrl}/admin/feedback-requests/${feedbackRequestId}`;

    return this._http.delete<CommandResult>(url);
  }

  public openAddReferenceCheckDialog(applicationId: number, selectionStepId: number, defaultEmailTemplateId: number | null, canAttachDocuments: boolean, isFeedbackRequest: boolean): Observable<boolean> {
    let data: FeedbackRequestDialogData = {
      applicationId: applicationId,
      selectionStepId: selectionStepId,
      defaultEmailTemplateId: defaultEmailTemplateId,
      canAttachDocuments: canAttachDocuments,
      showRecipient: !isFeedbackRequest
    };

    var dialog = this._dialogService.open(FeedbackRequestEditorComponent, {
      panelClass: ['largescreen-dialog', 'sc-full-height'],
      data: data
    });

    return dialog.afterClosed().pipe(
      map(r => !!r)
    );
  }

  public openFeedbackRequestsDialog(feedbackRequestId: number, canLockFeedbackForm: boolean): Observable<boolean> {
    let data: ReferenceCheckRequestDialogData = {
      feedbackRequestId: feedbackRequestId,
      canLockFeedbackForm: canLockFeedbackForm
    };

    var dialog = this._dialogService.open(FeedbackRequestsListComponent, {
      panelClass: ['largescreen-dialog', 'sc-full-height'],
      data: data
    });

    return dialog.afterClosed().pipe(
      map(r => !!r)
    );
  }
}

export interface SaveFeedbackRequestCDTO {
  userEmail: string;
  email: EmailCommand | null;
  selectionStepId: number;
  isCollectFeedback: boolean;
  templateVersionId: number | null;
}

export interface ReferenceCheckRequestListInitDTO {
  editorInitData: EditorData;
  requests: ReferenceCheckRequestListItemDTO;
  canceled: boolean;
  feedbackFormTemplateVersionId: number;
  applicationId: number;
  selectionStepId: number;
  canView: boolean;
}

export interface ReferenceCheckRequestListItemDTO {
  answered: boolean;
  publicId: string;
  userEmail: string;
  feedbackFormValues: FormValues | null;
}

export interface FeedbackRequestEditorInitDTO {
  feedbackForms: LookupItemDTO<any>[];
}
export interface FeedbackRequestInitDTO {
  allowedEmailTemplatesIds: number[];
  showEmailCC: boolean;
}
